const SET_STUDENTS = 'students/SET_STUDENTS';

const initialState = [];

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case SET_STUDENTS:
            // console.log("SET_STAFF", {...action.staff});
            return [...action.students];
        default:
            return state;
    }
};

const setStudents = function (students) {
    return {
        type: SET_STUDENTS,
        students: students
    }
};


export {
    reducer as default,
    initialState as initialStudentsState,
    setStudents,
}